/**
 * Function to generate pagination of records
 * @class Pagination
 * @memberof EBContext.modules
 */
EBContext.modules.Pagination = function (options) {
	options = options || {};
	this.options = EBContext.utils.extendObj(false, {
		innerOffsetLeft: 1,
		innerOffsetRight: 1,
		outerOffsetLeft: 2,
		outerOffsetRight: 2,
		maxLength: 9,
		paginationSelector: '#pagination',
		loadMoreSelector: '#loadMore',
		pageHref: function (i) {
			return EBContext.utils.createURL(null, {extendQS:true, requestParams: {page: i}});
		},
		hideSinglePage: true,
		blockDataPath: 'Result.page',
		paginationElement: 'UL',
		paginationClass: 'pagination flex-wrap m-0',
		paginationReload: '*page,pagination,resultWrap',
		loadMoreClass: 'btn btn-primary',
		loadMoreText: EBContext.resource('NACIST_DALSI'),
		loadMoreReload: '*page,pagination,resultWrap:resultWrap<',
		linkWrapClass: 'page-item mb-2',
		linkWrapActiveClass: 'active',
		linkClass: 'page-link text-default',
		linkAjaxOptions: {extendQS: true},
		loadMoreAjaxOptions: {extendQS: true},
		linkActiveClass : '',
		getPostData: function(){
			if (EBContext.ajaxNav){
				return EBContext.utils.getObj('ajaxNav.currentState.postData', EBContext);
			}
			return null;
		},
		onPaginate: null,
		onLoadMore: function (i) {
			var postData = self.options.getPostData();
			EBContext.ajaxNav.navigationTrigger(
				EBContext.utils.extendURL(window.location.href, {
					page: self.basePage + '-' + i
				}),
				EBContext.utils.createAjaxURL(window.location.href, EBContext.utils.extendObj(false, {
					reload: self.options.loadMoreReload,
					extendQS: true,
					requestParams: {
						page: i
					}
				}, self.options.loadMoreAjaxOptions)),
				postData,
				{
					updateURL: true,
					scrollTop: false,
					navigation: false,
					callback: ()=>{
						document.dispatchEvent(EBContext.ajaxNav.events.navigated);
					}
				}
			);
			return false;
		},
		renderCallback: function(elements){
			EBContext.ajaxNav.bindElements(EBContext.ajaxNav.findElements('link', elements), 'link');
		},
		renderPageItem: function(i, active){
			var pageWrapEl = document.createElement('li');
			pageWrapEl.className = self.options.linkWrapClass + (active && self.options.linkWrapActiveClass ? ' ' + self.options.linkWrapActiveClass : '');
			var pageEl = document.createElement('a');
			pageEl.className = self.options.linkClass + (active && self.options.linkActiveClass ? ' ' + self.options.linkActiveClass : '');
			pageEl.href = self.options.pageHref(i);
			pageEl.setAttribute('data-ajax', JSON.stringify(self.options.linkAjaxOptions));
			pageEl.innerHTML = i.toString();
			if(self.options.onPaginate && typeof self.options.onPaginate === 'function'){
				EBContext.utils.element.setOverride(pageEl, 'onclick', self.options.onPaginate);
			} 
			pageWrapEl.appendChild(pageEl);
			return pageWrapEl;
		},
		renderQuantifier: function(active){
			var pageWrapEl = document.createElement('li');
			pageWrapEl.className = 'page-item' + (active ? ' active' : '');
			var pageEl = document.createElement('span');
			pageEl.className = 'page-link';
			pageEl.innerText = '...';
			pageWrapEl.appendChild(pageEl);
			return pageWrapEl;
		},
		renderLoadMore: function(){
			var loadMoreEl = document.createElement('a');
			loadMoreEl.href = '?page=' + self.basePage + '-' + (self.activePage + 1);
			loadMoreEl.className = self.options.loadMoreClass;
			loadMoreEl.innerText = self.options.loadMoreText;
			loadMoreEl.onclick = function () {
				return self.options.onLoadMore(self.activePage + 1);
			};
			return loadMoreEl;
		}
	}, options);
	var self = this;

	this.basePage = 1;
	this.activePage = 1;
	this.pageResult = 1;
	this.recordsCount = 0;
	this.pagesCount = 0;

	this.init = function(options){
		if(options) self.options = EBContext.utils.extendObj(false, self.options, options);
		let urlParams = EBContext.utils.paramsStrToObj(window.location.href.toString().split('?')[1] || '', true);
		let page = (!urlParams.page ? '1' : urlParams.page);
		self.basePage = parseInt(page.split('-')[0]);
		self.activePage = parseInt(page.split('-').pop());
		
		let resultParams = EBContext.utils.getObj(self.options.blockDataPath + '.params', EBContext);
		if(!resultParams) resultParams = EBContext.utils.getObj('pages.' + self.options.blockDataPath + '.params', EBContext);
		self.recordsCount = resultParams.recordCount;
		self.pageResult = resultParams.pageResult;
		
		if(resultParams.maxPages && self.basePage < self.activePage-resultParams.maxPages+1) self.basePage = self.activePage-resultParams.maxPages+1;
		let pageCheck = self.basePage + (self.activePage === self.basePage ? '' : '-' + self.activePage);
		if(page !== pageCheck) EBContext.utils.updateURL(null, {page: pageCheck});
				
		if (self.options.paginationSelector) self.render();
		if (self.options.loadMoreSelector) self.renderLoadMore();
	};
	this.render = function (elements) {
		elements = elements || self.options.paginationSelector;
		if (typeof elements === 'string') elements = document.querySelectorAll(elements);
		if (elements) {
			self.pagesCount = Math.ceil(self.recordsCount / self.pageResult);
			if(self.pagesCount > 1 || !self.options.hideSinglePage){
				for(var eli = 0; eli < elements.length; eli++){ 
					var paginationEl = document.createElement(self.options.paginationElement);
					paginationEl.setAttribute('class', self.options.paginationClass);
					var dotsLeft = false,
						dotsRight = false,
						dotsLeftActive = false;
					if (self.pagesCount > self.options.maxLength) {
						if (self.activePage < self.pagesCount - self.options.outerOffsetRight - self.options.innerOffsetRight - 1) {
							dotsRight = true;
						}
						if (self.activePage > self.options.outerOffsetLeft + self.options.innerOffsetLeft + 1) {
							dotsLeft = true;
							if (self.basePage < self.activePage - self.options.innerOffsetLeft && self.basePage < self.pagesCount - self.options.maxLength + self.options.outerOffsetLeft + 2) dotsLeftActive = true;
		
						}
					}
					var i;
					for (i = 1; i < self.pagesCount + 1; i++) {
						var pageWrapEl, pageEl;
		
						//dots
						if ((dotsLeft && i === self.options.outerOffsetLeft + 1) || (dotsRight && i === self.pagesCount - self.options.outerOffsetRight - 1)) {
							var dotsActive = (dotsLeftActive && i === self.options.outerOffsetLeft + 1);
							paginationEl.appendChild(self.options.renderQuantifier(dotsActive));
							continue;
						}
		
						//skip items
						if (dotsRight && i < self.pagesCount - self.options.outerOffsetRight + 1 && i > self.activePage + self.options.innerOffsetRight && i > self.options.maxLength - self.options.outerOffsetRight - 1) continue;
						if (dotsLeft && i > self.options.outerOffsetLeft && i < self.activePage - self.options.innerOffsetLeft && i < self.pagesCount - self.options.maxLength + self.options.outerOffsetLeft + 2) continue;
		
						//render items
						paginationEl.appendChild(self.options.renderPageItem(i, (i >= self.basePage && i <= self.activePage)));
					}
	
					elements[eli].innerHTML = '';
					if (paginationEl) elements[eli].appendChild(paginationEl);
				}
			}
			else {
				for(var eli = 0; eli < elements.length; eli++){
					elements[eli].innerHTML = '';
				}
			}

			if (typeof self.options.renderCallback == 'function') {
				self.options.renderCallback(elements);
			}
		}
	};
	this.renderLoadMore = function (elements) {
		elements = elements || self.options.loadMoreSelector;
		if (typeof elements === 'string') elements = document.querySelectorAll(elements);
		for(var eli = 0; eli < elements.length; eli++){ 
			self.basePage = (typeof self.basePage === 'number' ? self.basePage : parseInt(self.basePage));
			self.activePage = (typeof self.activePage === 'number' ? self.activePage : parseInt(self.activePage));
			self.pagesCount = Math.ceil(self.recordsCount / self.pageResult);
			var loadMoreEl;
			if (self.activePage < self.pagesCount) {
				loadMoreEl = self.options.renderLoadMore();
			}

			elements[eli].innerHTML = '';
			if (loadMoreEl) elements[eli].appendChild(loadMoreEl);
		}
		
		if (typeof self.options.renderCallback == 'function') {
			self.options.renderCallback(elements);
		}
	};
};